import { LoadingLayer } from '../../LoadingLayer';
import { useEffect, useState } from 'react';
import { SideMenuAdmin } from './SideMenuAdmin';
import './Admin.css';
import '../schedule/Schedule.css';

const API_BASE = 'https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion';

const fetchSchedule = async () => {
  try {
    const response = await fetch(`${API_BASE}/admin/schedule`, {
      headers: { 'user-token': localStorage.getItem('id_token') },
    });
    const data = await response.json();
    return data.schedule;
  } catch (error) {
    console.error('Error fetching schedule:', error);
    return null;
  }
};

const saveSchedule = async (scheduleData) => {
  const response = await fetch(`${API_BASE}/admin/schedule`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': localStorage.getItem('id_token'),
    },
    body: JSON.stringify(scheduleData),
  });
  return response.json();
};

const emptyEvent = () => ({ time: '', code: '', title: '', speaker: '', location: '' });
const emptyDay = () => ({ dayLabel: '', date: '', events: [emptyEvent()] });
const emptyLink = () => ({ label: '', url: '' });

export const AdminSchedule = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [days, setDays] = useState([emptyDay()]);
  const [downloadLinks, setDownloadLinks] = useState([]);
  const [title, setTitle] = useState('Program');
  const [showPreview, setShowPreview] = useState(false);
  const [saveStatus, setSaveStatus] = useState('');

  useEffect(() => {
    setIsLoading(true);
    setLoadingMessage('Loading schedule...');
    fetchSchedule().then((schedule) => {
      if (schedule) {
        setTitle(schedule.title || 'Program');
        setDays(schedule.days && schedule.days.length > 0 ? schedule.days : [emptyDay()]);
        setDownloadLinks(schedule.download_links || []);
      }
      setIsLoading(false);
    });
  }, []);

  const addDay = () => setDays([...days, emptyDay()]);
  const removeDay = (di) => { if (days.length > 1) setDays(days.filter((_, i) => i !== di)); };
  const updateDay = (di, field, value) => {
    const u = [...days]; u[di] = { ...u[di], [field]: value }; setDays(u);
  };
  const addEvent = (di) => {
    const u = [...days]; u[di].events = [...u[di].events, emptyEvent()]; setDays(u);
  };
  const removeEvent = (di, ei) => {
    const u = [...days]; if (u[di].events.length > 1) { u[di].events = u[di].events.filter((_, i) => i !== ei); setDays(u); }
  };
  const updateEvent = (di, ei, field, value) => {
    const u = [...days]; u[di].events = [...u[di].events];
    u[di].events[ei] = { ...u[di].events[ei], [field]: value }; setDays(u);
  };
  const moveEvent = (di, ei, dir) => {
    const u = [...days]; const evs = [...u[di].events]; const t = ei + dir;
    if (t < 0 || t >= evs.length) return;
    [evs[ei], evs[t]] = [evs[t], evs[ei]]; u[di].events = evs; setDays(u);
  };
  const addLink = () => setDownloadLinks([...downloadLinks, emptyLink()]);
  const removeLink = (i) => setDownloadLinks(downloadLinks.filter((_, idx) => idx !== i));
  const updateLink = (i, field, value) => {
    const u = [...downloadLinks]; u[i] = { ...u[i], [field]: value }; setDownloadLinks(u);
  };

  const handleSave = async () => {
    setIsLoading(true); setLoadingMessage('Saving schedule...'); setSaveStatus('');
    try {
      await saveSchedule({ title, days, download_links: downloadLinks });
      setSaveStatus('saved'); setTimeout(() => setSaveStatus(''), 3000);
    } catch { setSaveStatus('error'); }
    setIsLoading(false);
  };

  const inp = { padding: '6px 10px', fontSize: '13px', border: '1px solid #ddd', borderRadius: '4px', outline: 'none', boxSizing: 'border-box' };
  const sinp = { ...inp, width: '100%' };
  const btn = { padding: '6px 14px', fontSize: '12px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 600, color: '#fff' };

  return (
    <div className="snn-user-home-main-wrapper">
      <SideMenuAdmin />
      <div className="snn-abstract-submission-main-grid-wrapper">
        <LoadingLayer isLoading={isLoading} action={loadingMessage} />
        <section className="snn-expand-grid-4">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '8px' }}>
            <h1 className="snn-user-home-main-content-header" style={{ margin: 0 }}>Schedule Editor</h1>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <button onClick={() => setShowPreview(!showPreview)} style={{ ...btn, backgroundColor: showPreview ? '#6366f1' : '#94a3b8' }}>
                <span className="material-symbols-outlined" style={{ verticalAlign: 'middle', fontSize: '16px', marginRight: 4 }}>{showPreview ? 'edit' : 'visibility'}</span>
                {showPreview ? 'Edit' : 'Preview'}
              </button>
              <button onClick={handleSave} style={{ ...btn, backgroundColor: saveStatus === 'saved' ? '#22c55e' : '#0b6ef6' }}>
                {saveStatus === 'saved' ? '✓ Saved' : 'Save Schedule'}
              </button>
              {saveStatus === 'error' && <span style={{ color: '#dc2626', fontSize: '12px', fontWeight: 600 }}>Error saving</span>}
            </div>
          </div>

          {/* ===== PREVIEW ===== */}
          {showPreview && (
            <div style={{ border: '2px solid #6366f1', borderRadius: '12px', padding: '24px', backgroundColor: '#fafafa' }}>
              <h2 style={{ textAlign: 'center', marginTop: 0 }}>{title}</h2>
              {downloadLinks.length > 0 && (
                <div className="schedule-links-wrapper" style={{ flexWrap: 'wrap', gap: '8px' }}>
                  {downloadLinks.map((link, i) => (
                    <a key={i} className="email-link" href={link.url} target="_blank" rel="noreferrer">
                      <span className="material-symbols-outlined">download</span> {link.label}
                    </a>
                  ))}
                </div>
              )}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px' }}>
                {days.map((day, di) => (
                  <div key={di}>
                    <h3 className="schedule-grid-day-title">{day.dayLabel}</h3>
                    <h2 className="schedule-grid-day-date">{day.date}</h2>
                    {day.events.map((ev, ei) => (
                      <div key={ei} className="schedule-grid-event">
                        <hr />
                        <p className="schedule-grid-event-hour">{ev.time}</p>
                        <p>
                          {ev.code && <><small className="schedule-grid-event-location">{ev.code}</small><br /></>}
                          {ev.title}
                          {ev.speaker && <><br />{ev.speaker}</>}
                          {ev.location && <><br /><small className="schedule-grid-event-location">{ev.location}</small></>}
                        </p>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ===== EDIT MODE ===== */}
          {!showPreview && (
            <div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ fontSize: '14px', fontWeight: 600, display: 'block', marginBottom: '4px' }}>Schedule Title</label>
                <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} style={{ ...inp, width: '300px' }} placeholder="Program" />
              </div>

              {/* Download links */}
              <div style={{ marginBottom: '24px', padding: '16px', backgroundColor: '#f8fafc', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                  <h3 style={{ margin: 0, fontSize: '15px' }}>Download Links</h3>
                  <button onClick={addLink} style={{ ...btn, backgroundColor: '#0b6ef6' }}>+ Add Link</button>
                </div>
                {downloadLinks.map((link, i) => (
                  <div key={i} style={{ display: 'flex', gap: '8px', marginBottom: '8px', alignItems: 'center' }}>
                    <input type="text" placeholder="Label" value={link.label} onChange={(e) => updateLink(i, 'label', e.target.value)} style={{ ...inp, flex: 1 }} />
                    <input type="text" placeholder="URL" value={link.url} onChange={(e) => updateLink(i, 'url', e.target.value)} style={{ ...inp, flex: 2 }} />
                    <button onClick={() => removeLink(i)} style={{ ...btn, backgroundColor: '#dc2626' }}>×</button>
                  </div>
                ))}
                {downloadLinks.length === 0 && <p style={{ color: '#94a3b8', fontSize: '13px', margin: 0 }}>No download links added.</p>}
              </div>

              {/* Days */}
              {days.map((day, di) => (
                <div key={di} style={{ marginBottom: '24px', padding: '16px', backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e5e7eb', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                    <h3 style={{ margin: 0, fontSize: '15px', color: '#333' }}>Day {di + 1}</h3>
                    <button onClick={() => removeDay(di)} disabled={days.length <= 1} style={{ ...btn, backgroundColor: days.length <= 1 ? '#ccc' : '#dc2626', cursor: days.length <= 1 ? 'not-allowed' : 'pointer' }}>Remove Day</button>
                  </div>
                  <div style={{ display: 'flex', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' }}>
                    <div style={{ flex: 1, minWidth: '150px' }}>
                      <label style={{ fontSize: '12px', color: '#666', display: 'block', marginBottom: '2px' }}>Day Label</label>
                      <input type="text" placeholder="e.g. Day 1" value={day.dayLabel} onChange={(e) => updateDay(di, 'dayLabel', e.target.value)} style={sinp} />
                    </div>
                    <div style={{ flex: 1, minWidth: '200px' }}>
                      <label style={{ fontSize: '12px', color: '#666', display: 'block', marginBottom: '2px' }}>Date</label>
                      <input type="text" placeholder="e.g. Monday, May 13" value={day.date} onChange={(e) => updateDay(di, 'date', e.target.value)} style={sinp} />
                    </div>
                  </div>
                  <div style={{ marginLeft: '8px', borderLeft: '3px solid #e5e7eb', paddingLeft: '16px' }}>
                    {day.events.map((ev, ei) => (
                      <div key={ei} style={{ marginBottom: '12px', padding: '12px', backgroundColor: '#f8fafc', borderRadius: '6px', border: '1px solid #eee' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                          <span style={{ fontSize: '12px', fontWeight: 600, color: '#94a3b8' }}>Event {ei + 1}</span>
                          <div style={{ display: 'flex', gap: '4px' }}>
                            <button onClick={() => moveEvent(di, ei, -1)} disabled={ei === 0} style={{ ...btn, backgroundColor: ei === 0 ? '#ccc' : '#94a3b8', padding: '2px 6px', fontSize: '11px' }}>↑</button>
                            <button onClick={() => moveEvent(di, ei, 1)} disabled={ei === day.events.length - 1} style={{ ...btn, backgroundColor: ei === day.events.length - 1 ? '#ccc' : '#94a3b8', padding: '2px 6px', fontSize: '11px' }}>↓</button>
                            <button onClick={() => removeEvent(di, ei)} disabled={day.events.length <= 1} style={{ ...btn, backgroundColor: day.events.length <= 1 ? '#ccc' : '#dc2626', padding: '2px 6px', fontSize: '11px' }}>×</button>
                          </div>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                          <div>
                            <label style={{ fontSize: '11px', color: '#666' }}>Time</label>
                            <input type="text" placeholder="9:00 AM - 10:00 AM" value={ev.time} onChange={(e) => updateEvent(di, ei, 'time', e.target.value)} style={sinp} />
                          </div>
                          <div>
                            <label style={{ fontSize: '11px', color: '#666' }}>Code</label>
                            <input type="text" placeholder="AMPN-O-01 or PLENARY 1 ✨" value={ev.code} onChange={(e) => updateEvent(di, ei, 'code', e.target.value)} style={sinp} />
                          </div>
                          <div style={{ gridColumn: '1 / -1' }}>
                            <label style={{ fontSize: '11px', color: '#666' }}>Title / Description</label>
                            <input type="text" placeholder="Event title" value={ev.title} onChange={(e) => updateEvent(di, ei, 'title', e.target.value)} style={sinp} />
                          </div>
                          <div>
                            <label style={{ fontSize: '11px', color: '#666' }}>Speaker</label>
                            <input type="text" placeholder="Speaker name (optional)" value={ev.speaker} onChange={(e) => updateEvent(di, ei, 'speaker', e.target.value)} style={sinp} />
                          </div>
                          <div>
                            <label style={{ fontSize: '11px', color: '#666' }}>Location</label>
                            <input type="text" placeholder="Auditorium CICESE" value={ev.location} onChange={(e) => updateEvent(di, ei, 'location', e.target.value)} style={sinp} />
                          </div>
                        </div>
                      </div>
                    ))}
                    <button onClick={() => addEvent(di)} style={{ ...btn, backgroundColor: '#0b6ef6', marginTop: '4px' }}>+ Add Event</button>
                  </div>
                </div>
              ))}
              <button onClick={addDay} style={{ ...btn, backgroundColor: '#0b6ef6', padding: '10px 20px', fontSize: '14px' }}>+ Add Day</button>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};
